'use client'

import { useMemo, useEffect, useState } from 'react';

const Cube = () => {
    const [mounted, setMounted] = useState(false);

    // Only set mounted to true after the first render
    useEffect(() => {
        setMounted(true);
    }, []);

    const style = useMemo(() => ({
        top: `${Math.floor(Math.random() * 95)}%`,
        left: `${Math.floor(Math.random() * 95)}%`,
        transform: `rotate(${Math.floor(Math.random() * 360)}deg)`,
    }), []);

    const getCubeStyles = () => {
        if (!mounted) return "bg-transparent"; // Prevent mismatch during hydration

        const apiKey = localStorage.getItem("api_key");
        if (!apiKey) return "bg-blue-300";

        const role_id = Number(localStorage.getItem("role_id"));
        switch (role_id) {
            case 1: return "bg-red-300/85";
            case 2: return "bg-[#DBF0FF]/95";
            case 3: return "bg-[#A1FFA5]";
            default: return "bg-blue-300";
        }
    };

    // If we haven't mounted yet, render a placeholder or nothing
    // This ensures the server and client start with the same HTML
    if (!mounted) return null;

    return (
        <div
            style={style}
            className={`absolute w-15 h-15 ${getCubeStyles()} blur-[5px] z-0`}
        />
    );
};

export const BgLayout = () => {
    const [count, setCount] = useState(0);

    useEffect(() => {
        // Randomize count only on the client
        let randomCount = Math.floor(Math.random() * 100);
        if (randomCount < 60) randomCount = Math.floor(Math.random() * 100);
        setCount(randomCount);
    }, []);

    return (
        <>
            {Array.from({ length: count }).map((_, index) => (
                <Cube key={index} />
            ))}
        </>
    );
};